// ======================================================================
// File Name       : thumbnail
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { commonCallApi } from '../../utils/ApiUtils';
import { STRUCTURE_LEVEL } from '../../constants';

export function editThumnail(data) {
  return commonCallApi({
    path: 'thumbnail/Edit',
    data,
    muiltipart: 1,
  });
}
export function defaultThumbnail(data) {
  return commonCallApi({
    path: 'defaultThumbnail/GetList ',
    data,
  });
}
